import { isNumericString } from './validations'

export const removeSubstringAtPositions = (str, start, end) => {
  const initialSubstring = str.substring(0, start)

  if (end === undefined || end === null) return initialSubstring

  if (end < start) throw new Error('End index must be greater than start index')

  return  initialSubstring + str.substring(end)
}

export const replaceSubstringAtPositions = (str, substr, start, end) => {
  return str.substring(0, start) + substr + str.substring(end)
}

export const removeLeadingZeros = (str) => {
  if(!isNumericString(str)) throw new Error('String must contain only numbers')

  return parseFloat(str).toString()
}

export const removeWhiteSpaces = (str) => {
  return str.replace(/ /g, '')
}

export const removeNonNumericChars = (str) => {
  return str.replace(/\D/g, '')
}

export const getUniqueCharacters = (str) => {
  const uniqueCharactersSet = new Set(str.split(''))

  return Array.from(uniqueCharactersSet)
}
